import { documentCacheService, DocumentInfo } from '../../../../../../shared/services/documentCacheService';
import { supabase } from '../../../../../../core/lib/supabase';

/**
 * Re-exportar DocumentInfo para compatibilidad
 */
export type { DocumentInfo };

/**
 * Genera una signed URL para un documento desde su storage_path.
 * Todos los documentos usan el bucket 'documents'.
 * En el nuevo modelo, el path es: {nodeId}/document.{ext}
 */
export async function generateDocumentUrl(storagePath: string | null | undefined): Promise<string | null> {
  if (!storagePath) {
    return null;
  }

  try {
    const { data: urlData, error: urlError } = await supabase.storage
      .from('documents')
      .createSignedUrl(storagePath, 3600); // 1 hora de expiración

    if (urlError) {
      console.warn(`⚠️ No se pudo generar URL para storage_path ${storagePath}:`, urlError);
      return null;
    }

    return urlData?.signedUrl || null;
  } catch (error) {
    console.warn(`⚠️ Error generando URL para storage_path ${storagePath}:`, error);
    return null;
  }
}

/**
 * Obtiene información de documentos (nombres y URLs) desde el caché unificado
 * Si no están en caché, se cargan automáticamente desde Supabase
 * 
 * @param documentIds - Array de IDs de documentos (node IDs)
 * @returns Promise con array de DocumentInfo
 */
export async function getDocumentsInfo(documentIds: string[]): Promise<DocumentInfo[]> {
  if (!documentIds || documentIds.length === 0) {
    return [];
  }

  // Usar el servicio de caché unificado
  return documentCacheService.getAssignationDocumentsInfo(documentIds);
}

/**
 * Extrae nombres de documentos del contenido del toolResult
 * Formato esperado: "Se encontraron X elementos:\n\n- DOCUMENTO: Nombre..."
 */
export function extractDocumentNames(content: string | undefined): string[] {
  if (!content) return [];

  const names: string[] = [];
  const lines = content.split('\n');

  for (const line of lines) {
    // Buscar líneas que contengan "DOCUMENTO:" o "Documento:"
    const match = line.match(/[-•]\s*(?:DOCUMENTO|Documento):\s*(.+)/i);
    if (match && match[1]) {
      names.push(match[1].trim());
    }
  }

  return names;
}
